// src/utils/ScrollToTop.tsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop component
 *
 * Handles scroll behavior on route changes:
 * - Scrolls to top when navigating to a new page (no hash)
 * - Scrolls to specific section when hash is present (#section-id)
 * - Uses requestAnimationFrame for better performance
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Use requestAnimationFrame for better performance and timing
    const scrollBehavior = () => {
      if (hash) {
        // Handle hash navigation (e.g., #contact-section)
        const elementId = hash.substring(1);
        const element = document.getElementById(elementId);

        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        } else {
          // If element not found, scroll to top
          window.scrollTo({ top: 0, left: 0, behavior: "instant" });
        }
      } else {
        // No hash - scroll to top instantly for better UX
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
      }
    };

    // Use requestAnimationFrame to ensure DOM is ready
    requestAnimationFrame(scrollBehavior);
  }, [pathname, hash]);

  return null;
}
